/** Safe post-login return paths (email deep-links, protected-route bounce). */

const BLOCKED_PREFIXES = ['/login', '/staff/login', '/pharmacy/login', '/purchase/login'];

/** Build `/login?next=…` preserving an optional `tenant` query. */
export function loginUrlWithReturn(pathname, search = '') {
  const path = pathname || '/';
  const rawSearch = search.startsWith('?') ? search.slice(1) : (search || '');
  const from = new URLSearchParams(rawSearch);
  const params = new URLSearchParams();
  const tenant = from.get('tenant');
  if (tenant) params.set('tenant', tenant);

  const next = `${path}${search || ''}`;
  if (path && path !== '/' && !BLOCKED_PREFIXES.some((p) => path === p || path.startsWith(`${p}?`))) {
    params.set('next', next);
  }

  const q = params.toString();
  return q ? `/login?${q}` : '/login';
}

/** Relative in-app path only — blocks open redirects. */
export function safePostLoginPath(search = '') {
  const raw = typeof search === 'string' && search.startsWith('?') ? search.slice(1) : (search || '');
  const params = new URLSearchParams(raw);
  let next = (params.get('next') || '').trim();

  // Legacy bounce left ?open=&intent= on /login — restore referral inbox deep-link
  if (!next) {
    const open = (params.get('open') || '').trim();
    const intent = (params.get('intent') || '').trim().toLowerCase();
    if (open) {
      next = `/management/referral-inbox?open=${encodeURIComponent(open)}`;
      if (intent === 'approve' || intent === 'reject') {
        next += `&intent=${encodeURIComponent(intent)}`;
      }
    }
  }

  if (!next.startsWith('/') || next.startsWith('//') || next.includes('://')) return null;
  if (BLOCKED_PREFIXES.some((p) => next === p || next.startsWith(`${p}?`))) return null;
  return next;
}
